module.exports = __webpack_public_path__ + "img/test_tower_image.2c28b592.png";